const config = require('./configs/consumer');
const User = require('./user');
const RequestError = require('./requestError');
const snakeToCamel = require('./utils/snakeToCamel');
const deepExtend = require('./utils/deepExtend');

function Consumer(options) {
  const consumer = new User(deepExtend({}, config, options));

  /**
   *
   */
  consumer.registrationBegin = function(
    email,
    password,
    phoneNumber = null,
    fullName = null,
    kwargs = {},
  ) {
    return this.registrationManger
      .create(email, password, phoneNumber, fullName, kwargs)
      .catch(function(error) {
        throw new RequestError(error);
      });
  };

  /**
   *
   */
  consumer.registrationUpdate = function(data) {
    const requiredFields = [
      'first_name',
      'last_name',
      'country',
      'phone_number',
      'date_of_birth',
      'agreement',
    ];

    // Prepare data in sent data with proper formatting
    const profile = requiredFields.reduce((obj, field) => {
      const fieldCamel = snakeToCamel(field);
      obj[field] = data[fieldCamel];
      return obj;
    }, {});

    return this.registrationManger.update({ profile }).catch(function(error) {
      throw new RequestError(error);
    });
  };

  /**
   *
   */
  consumer.registrationValidate = function() {
    return this.registrationManger.validate().catch(function(error) {
      throw new RequestError(error);
    });
  };

  /**
   *
   */
  consumer.registrationVerification = function(code) {
    return this.registrationManger
      .verify(code)
      .then(function(data) {
        return data.token;
      })
      .catch(function(error) {
        throw new RequestError(error);
      });
  };

  return consumer;
}

module.exports = Consumer;
